import React, { Fragment, useState } from 'react'
import Header from './Header'
import About from './About'
import Motivation from './Motivation'
import Achievements from './Achievements'
import Info from './Info'
import { FooterWithForm } from './Footer'
import { Subject, Dates, Timing } from '@app/components/shared/StateLabel/Label'
import Rewards from "./Rewards";

const Landing = ({ global, route }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { event } = global;

  const openMobileModal = () => {
    setIsOpen(true);
  }

  const closeMobileModal = () => {
    setIsOpen(false);
  }

  return (
    <Fragment>
      <Header global={global} route={route} handleModal={openMobileModal} />
      <Achievements />
      <>
        <div className="section running-now-section" style={{paddingBottom: '30px'}}>
          <h1 className="plate-heading plate-heading--left">
            Practice Stage
          </h1>
          <div className="plate plate--info plate--xl m-0 mt-2" style={{border: '1px solid black'}}>
            <div className="grid">
              <Subject event={event} tourName={'Warm-Up Stage'}/>
              <div className="grid">
                <Dates event={event} tour="trial"/>
                <Timing event={event} iconClassName="f--all-default" textTiming={'Students can practise at their own pace with unlimited attempts'}/>
              </div>
            </div>
          </div>
        </div>
        <div className="section running-now-section" style={{paddingTop: 0}}>
          <h1 className="plate-heading plate-heading--left">
            Competition Stage
          </h1>
          <div className="plate plate--info plate--xl m-0 mt-2" style={{border: '1px solid black'}}>
            <div className="grid">
              <Subject event={event} tourName={'DinoMath Olympiad'}/>
              <div className="grid">
                <Dates event={event} tour="main"/>
                <Timing event={event} iconClassName="f--all-default" textTiming={'During this period, students can enter the Olympiad at any time. They will have\xa01 hour to solve all tasks.'}/>
              </div>
            </div>
          </div>
          <div className="plate plate--info plate--xl m-0 mt-2" style={{border: '1px solid black'}}>
            <div className="grid">
              <Subject event={event} tourName={'Final Round'}/>
              <div className="grid">
                <Dates event={event} tour="final"/>
                <Timing
                  event={event}
                  iconClassName="f--all-default"
                  textTiming={'During this period, the students who have scored the best in the previous round will be able to participate in quizzes with children from different schools in India.'}
                />
              </div>
            </div>
          </div>
        </div>
      </>
      <Rewards />
      <Motivation />
      <Info global={global} type="not-auth" />
      <About extraPadding type="not-auth" />
      <FooterWithForm />
    </Fragment>
  )
}

export default Landing

